import { useMutation } from "@apollo/client";
import { RESTORE_PRUNED_CLIP } from "MVVM/GraphQL/restorePrunedClip";
import { CLIP_REQUEST } from "MVVM/GraphQL/singleClip";

export const MomentClipViewModel = () => {
  const [createPrunedClip] = useMutation(RESTORE_PRUNED_CLIP, {
    onError: () => {},
    refetchQueries: [CLIP_REQUEST],
  });

  return {
    createPrunedClip,
  };
};
